import baseAPI from './axiosApi'

const api={
    list:'/api-ir/hr/base/list',
    add:'/api-ir/hr/base/add',
    update:'/api-ir/hr/base/update',
    info:'/api-ir/hr/base/',
    del:'/api-ir/hr/base/',
    getXzqh:'/api-d/codeXzqh/getXzqh',
    getTeacher:'/api-ir/hr/base/queryByNameOrNo',
    export:'/api-ir/hr/base/export',
}
// 查询人事列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增人事
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改人事
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询人事
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除人事
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 获取行政区划
export function getXzqh (data) {
    return baseAPI.axiosData(api.getXzqh,'get',data)
}
// 模糊查询教师列表
export function getTeacher (data) {
    return baseAPI.axiosData(api.getTeacher,'get',data)
}
// 模糊查询教师列表
export function exportTable (data) {
    return baseAPI.axiosData(api.export,'post',data)
}
